// extracted by mini-css-extract-plugin
module.exports = {"banner":"PsaBanner_banner__cjHwW","wrapper":"PsaBanner_wrapper__k_y4G","content":"PsaBanner_content__g0x2L","close":"PsaBanner_close__ePiVH"};